
const styles = () => ({
    menu: {
        minWidth: "200px",
    },
})

export default styles
